<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="notificationsList"
      :search="search"
      :loading="fetchingItems"
      :no-data-text="$t('noDataFount')"
      :no-results-text="$t('noDataFount')"
      hide-default-footer
      :footer-props="{
        'items-per-page-text': this.$t('rowsPerPage'),
      }"
    >
      <template v-slot:top>
        <v-row
          no-gutters
          class="d-print-none align-center pa-4"
          :style="breakpoint ? 'gap: 16px;' : ''"
        >
          <v-col cols="12" md="8" sm="8">
            <AddNotification
              @fetchNotificationsList="fetchNotificationsList"
            />
          </v-col>

          <v-col cols="12" md="4" sm="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
              @click:clear="clearSearchInput()"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.id`]="{ item }">
        <v-btn @click="$copy(item.id)" x-small>
          {{ item.id }}
        </v-btn>
      </template>

      <template v-slot:[`item.id_usuario`]="{ item }">
        <v-btn
          v-if="item.id_usuario"
          @click="$copy(item.id_usuario)"
          x-small
        >
          {{ item.id_usuario }}
        </v-btn>
        <span v-else> - </span>
      </template>

      <template v-slot:[`item.descricao`]="{ item }">
        <span style="max-width: 200px;" class="d-inline-block text-truncate">{{ item.descricao}}</span>
      </template>

      <template v-slot:[`item.viewed`]="{ item }">
        <span
          v-if="item.viewed != $t('notViewed') &&
            item.viewed != $t('viewed')
          "
          class="d-flex justify-center"
        > - </span>
        <v-chip v-else
          small
          :class="item.viewed != $t('viewed') ? 'warning' : 'success'"
        >
          {{ item.viewed }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn-toggle>
          <SeeNotification
            :notification="{
              id: item.id,
              description: item.descricao
            }"
          />
            <!-- <EditNotification
              :notification="{
                id: item.id,
                description: item.descricao
              }"
              @fetchNotificationsList="fetchNotificationsList"
            /> -->
          <DeleteNotification
            :notification="{
              id: item.id,
              description: item.descricao
            }"
            @fetchNotificationsList="fetchNotificationsList"
          />
        </v-btn-toggle>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <v-pagination
      v-if="!isSearching"
      v-model="page"
      :length="pageCount"
      :total-visible="5"
      :disabled="notificationsList.length == 0"
      class="py-3"
    ></v-pagination>
  </v-card>
</template>

<script>
import AddNotification from "./addNotification.vue"
import SeeNotification from "./seeNotification.vue"
// import EditNotification from "./editNotification.vue"
import DeleteNotification from "./deleteNotification.vue"
export default {
  components: {
    AddNotification,
    SeeNotification,
    // EditNotification,
    DeleteNotification
  },
  name: "users-notifications",
  data: (vm) => ({
    search: "",
    fetchingItems: false,
    headers: [
      { text: "ID", value: "id" },
      { text: vm.$t("description"), value: "descricao", width: "200" },
      { text: vm.$t("idUser"), value: "id_usuario" },
      { text: vm.$t("date"), value: "date_notification" },
      { text: "Status", value: "viewed" },
      { text: vm.$t("actions"), value: "actions" },
    ],
    notificationsList: [],
    // Pagination
    isSearching: false,
    page: 1,
    nextPage: null,
    pageCount: 1,
    cachedPage: {},
    latestRangeDate: {},
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilter() {
      return this.$store.state.filters.save;
    },
    rangeDateHasChanged() {
      if (!this.latestRangeDate.data_inicio) return false;
      return this.latestRangeDate.data_inicio != this.rangeDate.data_inicio ||
        this.latestRangeDate.data_final != this.rangeDate.data_final
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name == 'xs';
    }
  },

  mounted() {
    this.fetchingItems = true;
    setTimeout(() => {this.fetchNotificationsList()}, 1000)
  },

  watch: {
    saveFilter(bool) {
      bool && this.fetchNotificationsList();
    },
    page() {
      this.fetchNotificationsList();
    },
    search(string) {
      this.filterPages(string);
    },
  },

  methods: {
    fetchNotificationsList(fecthEmitedByChildren) {
      if (this.rangeDateHasChanged) {
        this.page = 1;
        this.pageCount = 1;
        this.cachedPage = {};
      }

      const body = {
        ...this.rangeDate,
        page: this.page,
      }

      this.fetchingItems = true;
      this.notificationsList = [];

      if (!fecthEmitedByChildren && !this.rangeDateHasChanged) {
        if (this.cachedPage[this.page]) {
          this.notificationsList = this.cachedPage[this.page]
          this.fetchingItems = false;
          this.$store.commit("setFeedbackProgress", false);
          this.$store.commit("setSave", false);
          this.$store.commit("DisabledSave", false);
          return
        }
      }

      this.$axios
        .post(
          `${this.$prefix()}/notifications/listNotifications`,
          body
        )
        .then((resp) => {
          this.fetchingItems = false;
          // handle dados.length == 0 status 200
          if (resp.data.dados.length == 0) {
            this.$store.commit("setFeedbackSnack", {
                  msg: this.$t("noDataFount"),
                  color: "warning",
                }
              );

            return
          }

          const currentPage = resp.data.this_page;
          const nextPage = resp.data.next_page;
          if (currentPage && nextPage) {
            this.nextPage = nextPage;
            this.pageCount = this.nextPage;
          } else {
            this.nextPage = null;
          }

          this.notificationsList = resp.data.dados;

          this.notificationsList.forEach((item) => {
            item.viewed = this.chipCSS(item.viewed);
            item.date_notification = this.$handleDate(item.date_notification).date;
          });

          this.cachedPage[this.page] = this.notificationsList;
          this.latestRangeDate = {...this.rangeDate};
        })
        .catch(() => {
          this.fetchingItems = false;
        })
    },

    filterPages(searchString) {
      const searchStrToLowerCase = searchString && searchString.toLowerCase()
      const matches = [];

      for (const key in this.cachedPage) {
        const arrayObjects = this.cachedPage[key];

        for (const object of arrayObjects) {
          for (const prop in object) {
            if (object[prop] && object[prop].toLowerCase().includes(searchStrToLowerCase)) {
              matches.push({ key, object });
              break; // Para evitar que o mesmo objeto seja adicionado várias vezes
            }
          }
        }
      }
      
      if (searchStrToLowerCase) {
        this.isSearching = true;
        this.notificationsList = matches.map((item) => item.object);
      } else {
        this.stopSearching();
      }
    },

    stopSearching() {
      this.search = "";
      this.isSearching = false;
      this.notificationsList = this.cachedPage[this.page];
    },

    clearSearchInput() {
      this.stopSearching();
    },

    showDialog() {
      this.$store.commit("showDialog", true);
    },

    chipCSS(viewed) {
      if (viewed == 0) return this.$t("notViewed");
      if (viewed == 1) return this.$t("viewed");
    }
  }
}
</script>